import React from 'react';
import { useFormikContext } from 'formik';
import STATE_OPTIONS from 'shared/states.json';
import { BUSINESS_CATEGORY } from 'shared';
import TextInput from 'components/FormElements/TextInput';
import CustomSelect from 'components/FormElements/CustomSelect';
import './merchant-form.css';

function selectOption(key = '') {
  return STATE_OPTIONS.find((option) => option.name === key);
}

const Section = ({ title, description, children }) => (
  <section className='form-section'>
    <header className='form-section-header'>
      <h4 className='form-section-title'>{title}</h4>
      {description && <p className='form-section-description'>{description}</p>}
    </header>
    <div className='form-grid'>{children}</div>
  </section>
);

const MerchantForm = () => {
  const [selectedStateOfBusiness, setSelectedStateOfBusiness] = React.useState('');
  const { setFieldValue, values } = useFormikContext();

  const lgas = React.useMemo(() => {
    const selectedValidState = selectOption(selectedStateOfBusiness);
    if (selectedValidState) return selectedValidState.lgas;
    return [];
  }, [selectedStateOfBusiness]);

  return (
    <div className='form-wrapper'>
      <Section title='Identity' description='Who the merchant is.'>
        <TextInput className='add-merchant-item' name='firstName' label='First Name' placeholder='First name' required />
        <TextInput className='add-merchant-item' name='lastName' label='Last Name' placeholder='Last name' required />
        <CustomSelect
          className='add-merchant-item form-field-full'
          id='stateOfOrigin'
          name='stateOfOrigin'
          label='State of Origin'
          options={STATE_OPTIONS}
          onChange={(option) => setFieldValue('stateOfOrigin', option.value)}
          defaultInputValue={values.stateOfOrigin}
          required
        />
      </Section>

      <Section title='Contact' description='How we reach them.'>
        <TextInput className='add-merchant-item form-field-md' name='phoneNumber' label='Phone Number' placeholder='0801 234 5678' required />
        <TextInput className='add-merchant-item form-field-lg' type='email' name='email' label='Email' placeholder='jane.doe@example.com' />
      </Section>

      <Section title='Business Address' description='Where the business operates.'>
        <TextInput className='add-merchant-item form-field-full' name='address' label='Street Address' placeholder='e.g., 8 Oduduwa Crescent' required />
        <CustomSelect
          className='add-merchant-item form-field-md'
          id='businessState'
          name='state'
          label='State'
          options={STATE_OPTIONS}
          onChange={(option) => {
            setFieldValue('state', option.value);
            setSelectedStateOfBusiness(option.value);
          }}
          defaultInputValue={values.state}
          required
        />
        <CustomSelect
          className='add-merchant-item form-field-md'
          id='businessLga'
          name='lga'
          label='L.G.A'
          isDisabled={!values.state}
          options={lgas}
          onChange={(option) => setFieldValue('lga', option.value)}
          defaultInputValue={values.lga}
          required
        />
        <TextInput className='add-merchant-item form-field-md' name='city' label='City' placeholder='Ikeja' required />
        <TextInput className='add-merchant-item' name='nearestBusStop' label='Nearest Bus Stop' placeholder='e.g., Ojota' />
      </Section>

      <Section title='Business Profile' description='Account and classification used for settlement and reporting.'>
        <TextInput className='add-merchant-item form-field-md' name='accountNumber' label='Account Number' placeholder='10-digit NUBAN' required />
        <TextInput className='add-merchant-item form-field-md' name='bankCode' label='Bank Code' placeholder='058' required />
        <TextInput className='add-merchant-item form-field-md' name='bankName' label='Bank Name' placeholder='Guaranty Trust Bank' required />
        <TextInput className='add-merchant-item form-field-md' name='businessStartDate' label='Business Start Date' type='date' required />
        <CustomSelect
          className='add-merchant-item form-field-full'
          id='businessSegment'
          name='businessSegment'
          label='Business Category'
          options={BUSINESS_CATEGORY}
          onChange={(option) => setFieldValue('businessSegment', option.value)}
          defaultInputValue={values.businessSegment}
          required
        />
      </Section>
    </div>
  );
};

export default MerchantForm;
